import React, { useEffect, useState } from "react";
import {
    Container,
    Row,
    Col,
    Image,
    Badge,
    OverlayTrigger,
    Popover,
} from "react-bootstrap";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import Spinner from "../../components/spinner/spinner.component";
import GoogleMap from "google-map-react";
import TeamImage from "../../assets/team.png";
import { Modal } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import InquiryModel from "../../services/InquiryModel";
import InquiryForm from "../inquiry-form/inquiry-form.component";
import ImageMarker from "../image-marker";
import AuthUser from "../../services/AuthUser";

import "./property-detail.styles.scss";

function PropertyDetail() {
    const { slug } = useParams();
    const [plots, setPlots] = useState([]);
    //const title = slug.replaceAll("-", " ");
    const [property, setProperty] = useState({});
    let [loading, setLoading] = useState(true);
    const [markers, setMarkers] = useState([]);
    const { user } = AuthUser();
    //  const { height, width } = useWindowDimensions();
    const getPropertyData = (slug) => {
        axios.get(API_URL.PROPERTY, { params: { slug: slug } }).then(
            (res) => {
                if (res.data.code === 200) {
                    setProperty(res.data.data);
                    setLoading(false);
                    setPlots(res.data.data.plot_details);
                }
            },
            (error) => {}
        );
    };

    const setPlotXY = (plots) => {
        if (plots != null) {
            let newMarkers = plots.map((item) => {
                let top =
                    item.img_data && item.img_data.x ? item.img_data.x : 0;
                let left =
                    item.img_data && item.img_data.y ? item.img_data.y : 0;
                return { ...item, top, left };
            });

            setMarkers(newMarkers);
        }
    };
    useEffect(() => {
        setPlotXY(plots);
    }, [plots]);

    useEffect(() => {
        getPropertyData(slug);
    }, [slug]);

    useEffect(() => {
        getPropertyData(slug);
    }, [slug]);

    const defaultProps = {
        center: {
            lat: 23.033863,
            lng: 72.585022,
        },
        zoom: 12,
    };

    const CustomMarker = (marker) => {
        return (
            <OverlayTrigger
                trigger="hover, focus"
                placement="top"
                overlay={
                    <Popover id="popover-basic">
                        <Popover.Header as="h3">
                            Plot no: {marker.plot_no}
                        </Popover.Header>
                        <Popover.Body>
                            <div>
                                <strong>Plot Size: </strong>
                                {marker.sq_yard} Sq.Yard
                            </div>
                            <div>
                                <strong>Plot Size: </strong>
                                {marker.sq_feet} Sq.Feet
                            </div>
                        </Popover.Body>
                    </Popover>
                }
            >
                <div
                    className="image-marker__marker image-marker__marker--default"
                    data-testid="marker"
                >
                    {marker.plot_no}
                </div>
            </OverlayTrigger>
        );
    };

    const [inquiryShow, setInquiryShow] = useState(false);
    const handleInquiryShow = () => setInquiryShow(true);
    const handleInquiryClose = () => setInquiryShow(false);
    const { httpInquiry } = InquiryModel();
    const onInquiryFormSubmit = (data) => {
        httpInquiry
            .post(API_URL.INQUIRY, data)
            .then((res) => {
                if (res.data.code === 200) {
                    handleInquiryClose();
                    NotificationManager.success(
                        res.data.msg,
                        "Successful!",
                        2000
                    );
                } else {
                    NotificationManager.error(res.data.msg, "Error!");
                }
            })
            .catch((err) => {
                NotificationManager.error(
                    "Error while submit inquiry!",
                    "Error!"
                );
            });
    };

    return (
        <React.Fragment>
            {loading ? (
                <Spinner />
            ) : property ? (
                <React.Fragment>
                    <section className="listing-title-area">
                        <Container>
                            <Row className="mb30">
                                <Col lg="7" xl="8">
                                    <div className="single_property_title">
                                        <h2>{property.name}</h2>
                                        <p>{property.address}</p>
                                    </div>
                                    <div className="spls_style_two mb30-520">
                                        <ImageMarker
                                            src={property.images}
                                            markers={markers}
                                            markerComponent={CustomMarker}
                                        />
                                    </div>
                                </Col>
                                <Col lg="5" xl="4">
                                    <div className="single_property_social_share">
                                        <div className="price float-left fn-400">
                                            <h2>Available Plots</h2>
                                        </div>
                                    </div>
                                    <div className="slots-wrapper">
                                        <div className="slots-container">
                                            {property.plot_details &&
                                                property.plot_details.map(
                                                    (plot, index) => (
                                                        <div
                                                            key={index}
                                                            className={`slots-body-container ${
                                                                plot.status ===
                                                                "1"
                                                                    ? ""
                                                                    : "sold"
                                                            }`}
                                                        >
                                                            <div className="slot-header">
                                                                <span>
                                                                    {
                                                                        plot.plot_no
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div className="slot-body">
                                                                {plot.status ===
                                                                "1" ? (
                                                                    ""
                                                                ) : (
                                                                    <Badge bg="warning">
                                                                        SOLD
                                                                    </Badge>
                                                                )}
                                                                <div>
                                                                    <strong>
                                                                        Plot
                                                                        Size:{" "}
                                                                    </strong>
                                                                    {
                                                                        plot.sq_yard
                                                                    }{" "}
                                                                    Sq.Yard
                                                                </div>
                                                                <div>
                                                                    <strong>
                                                                        Plot
                                                                        Size:{" "}
                                                                    </strong>
                                                                    {
                                                                        plot.sq_feet
                                                                    }{" "}
                                                                    Sq.Feet
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section className="sticky_heading h60 p0">
                        <Container>
                            <Row className="mb30">
                                <Col xl="12">
                                    <div className="sticky-nav-tabs">
                                        <ul className="sticky-nav-tabs-container">
                                            <li className="list-inline-item nav-item active">
                                                <a
                                                    className="sticky-nav-tab"
                                                    href="#tab-1"
                                                >
                                                    Details
                                                </a>
                                            </li>
                                            <li className="list-inline-item nav-item">
                                                <a
                                                    className="sticky-nav-tab"
                                                    href="#tab-3"
                                                >
                                                    Locations
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    <section className="our-listing-single bgc-f7 pb30-991 pt30-991">
                        <Container>
                            <Row className="mb30">
                                <Col md="12" lg="8">
                                    <Row>
                                        <Col lg="12">
                                            <div className="listing_single_description">
                                                <h4 className="mb30">
                                                    Description
                                                </h4>
                                                <p className="mb25">
                                                    {
                                                        property.general_description
                                                    }
                                                </p>
                                            </div>
                                            <div className="additional_details">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <h4 className="mb15">
                                                            Property Details
                                                        </h4>
                                                    </div>
                                                    <div className="col-md-12 col-lg-12 col-xl-12">
                                                        <ul className="list-inline-item">
                                                            <li>
                                                                <p>
                                                                    Total Land :
                                                                    <span>
                                                                        {property.total_land.toFixed(
                                                                            2
                                                                        )}
                                                                    </span>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    Price :
                                                                    <span>
                                                                        $
                                                                        {
                                                                            property.cost
                                                                        }
                                                                    </span>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    Property
                                                                    Type:
                                                                    <span>
                                                                        {
                                                                            property.property_type
                                                                        }
                                                                    </span>
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    Neighborhood
                                                                    Address:
                                                                    <span>
                                                                        {
                                                                            property.neighborhood_address
                                                                        }
                                                                    </span>
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="property_attachment_area">
                                                <h4 className="mb30">
                                                    Property Documents
                                                </h4>
                                                {user ? (
                                                    <div>
                                                        <div className="iba_container style2">
                                                            <div className="icon_box_area style2">
                                                                <div className="score">
                                                                    <span className="flaticon-document text-thm fz30"></span>
                                                                </div>
                                                                <div className="details">
                                                                    <h5>
                                                                        <Link
                                                                            to={
                                                                                property
                                                                                    .documents
                                                                                    .legal_doc
                                                                            }
                                                                        >
                                                                            <span className="flaticon-download text-thm pr10"></span>{" "}
                                                                            Legal
                                                                            Document
                                                                        </Link>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                            <div className="icon_box_area style2">
                                                                <div className="score">
                                                                    <span className="flaticon-document text-thm fz30"></span>
                                                                </div>
                                                                <div className="details">
                                                                    <h5>
                                                                        <Link
                                                                            to={
                                                                                property
                                                                                    .documents
                                                                                    .tax_doc
                                                                            }
                                                                        >
                                                                            <span className="flaticon-download text-thm pr10"></span>{" "}
                                                                            Tax
                                                                            Document
                                                                        </Link>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="iba_container style2">
                                                            <div className="icon_box_area style2">
                                                                <div className="score">
                                                                    <span className="flaticon-document text-thm fz30"></span>
                                                                </div>
                                                                <div className="details">
                                                                    <h5>
                                                                        <Link
                                                                            to={
                                                                                property
                                                                                    .documents
                                                                                    .finance_doc
                                                                            }
                                                                        >
                                                                            <span className="flaticon-download text-thm pr10"></span>{" "}
                                                                            Finance
                                                                            Document
                                                                        </Link>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p className="mb25">
                                                            {property.notes}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <p className="mb25">
                                                        Please login to view the
                                                        property documents.
                                                    </p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col lg="12">
                                            <div
                                                id="tab-3"
                                                className="application_statics mt30"
                                            >
                                                <h4 className="mb30">
                                                    Location
                                                    <small className="float-right">
                                                        {property.address}
                                                    </small>
                                                </h4>
                                                <div className="property_video p0">
                                                    <div className="thumb">
                                                        <div className="h400">
                                                            <GoogleMap
                                                                defaultCenter={
                                                                    defaultProps.center
                                                                }
                                                                defaultZoom={
                                                                    defaultProps.zoom
                                                                }
                                                            ></GoogleMap>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg="4" xl="4">
                                    <div className="sidebar_listing_list">
                                        <div className="sidebar_advanced_search_widget">
                                            <div className="sl_creator">
                                                <div className="media align-items-center">
                                                    <Image
                                                        className="mr-3"
                                                        src={
                                                            property.cliff.photo
                                                                ? property.cliff
                                                                      .photo
                                                                : TeamImage
                                                        }
                                                        alt={
                                                            property.cliff_name
                                                        }
                                                    />
                                                    <div className="media-body">
                                                        <h5 className="mt-0 mb0">
                                                            {
                                                                property.cliff
                                                                    .name
                                                            }
                                                        </h5>
                                                        <p className="mb0">
                                                            {
                                                                property.cliff
                                                                    .phone_number
                                                            }
                                                        </p>
                                                        <p className="mb0">
                                                            {property.email}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="sasw_list mb0">
                                                <li>
                                                    <div className="search_option_button">
                                                        <button
                                                            type="button"
                                                            className="btn btn-block btn-thm"
                                                            onClick={
                                                                handleInquiryShow
                                                            }
                                                        >
                                                            Inquiry Now
                                                        </button>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <Modal
                        show={inquiryShow}
                        onHide={handleInquiryClose}
                        className="inquiryModal"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Body>
                            <InquiryForm
                                onSubmit={onInquiryFormSubmit}
                                property={property}
                            />
                        </Modal.Body>
                    </Modal>
                </React.Fragment>
            ) : (
                "Property not Found"
            )}
        </React.Fragment>
    );
}

export default PropertyDetail;
